import React, { useEffect, useState } from "react";
import { Table, Button, Popconfirm } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTemples, deleteATemple } from "../features/temple/templeSlice";
import { toast } from "react-toastify";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Location",
    dataIndex: "location",
    sorter: (a, b) => a.location.length - b.location.length,
  },
  {
    title: "Deity",
    dataIndex: "deity",
    sorter: (a, b) => a.deity.length - b.deity.length,
  },
  {
    title: "Status",
    dataIndex: "isActive",
    render: (isActive) => (
      <span className={isActive ? "badge bg-success" : "badge bg-danger"}>
        {isActive ? "Active" : "Inactive"}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Templelist = () => {
  const [open, setOpen] = useState(false);
  const [templeId, setTempleId] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getTemples());
  }, []);

  const showModal = (e) => {
    setOpen(true);
    setTempleId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const templeState = useSelector((state) => state.temple.temples);
  const data1 = [];
  for (let i = 0; i < templeState.length; i++) {
    data1.push({
      key: i + 1,
      name: templeState[i].name,
      location: templeState[i].location,
      deity: templeState[i].deity,
      isActive: templeState[i].isActive,
      createdAt: new Date(templeState[i].createdAt).toLocaleString(),
      action: (
        <>
          <Button
            className="bg-transparent border-0 text-primary fs-5 me-3"
            onClick={() => {
              navigate(`/admin/temple/${templeState[i]._id}`);
            }}
          >
            <BiEdit />
          </Button>
          <Button
            className="bg-transparent border-0 text-danger fs-5"
            onClick={() => showModal(templeState[i]._id)}
          >
            <AiFillDelete />
          </Button>
        </>
      ),
    });
  }

  const deleteTemple = (e) => {
    dispatch(deleteATemple(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getTemples());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Temples List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteTemple(templeId);
        }}
        title="Are you sure you want to delete this temple?"
      />
    </div>
  );
};

export default Templelist;